// @flow
import { windowWrapper } from '@clubmed/utils';
import classnames from 'classnames';
import { isFunction } from 'lodash';
import React, { Fragment, useEffect } from 'react';

import appConfig from 'Config';
import { useScriptLoader } from 'Src/hooks/use-script-loader/useScriptLoader';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

export type WibilongPopinButtonProps = {
  className?: string,
  country: string,
  language: string,
  productId: string,
  trackingData?: TrackingData,
};

export const WibilongPopinButton = (props: WibilongPopinButtonProps) => {
  const dataUrl = appConfig.get('social.wibilong.appUrl');
  const isEnabled = appConfig.get('social.wibilong.enabled');
  const scriptUrl = appConfig.get('social.wibilong.scriptUrl');
  const { scriptLoaded } = useScriptLoader(scriptUrl);
  useEffect(
    () => {
      if (isEnabled) {
        const wibilongPopin = windowWrapper.get('wibilongPopin');
        if (wibilongPopin && isFunction(wibilongPopin.init)) {
          wibilongPopin.init();
        }
      }
    },
    [scriptLoaded],
  );

  const { className, country, language, productId, trackingData } = props;

  return (
    <Fragment>
      {!isEnabled ? null : (
        <TrackClick
          as="div"
          className={classnames(className, 'WibilongPopinButton')}
          trackingData={trackingData}
        >
          <div
            id="PopinDiv"
            data-url={dataUrl}
            data-product={`${productId}${country}${language}`}
          />
        </TrackClick>
      )}
    </Fragment>
  );
};
